'use client';
import classNames from 'classnames';
import './index.scss';
import { useLang } from '@/i18n';

export interface EfFootNotesProps {
    /**
     * langKey
     */
    langKey: string;
    /**
     * links集合 i18n文案key值必须是 a1，a2, a3...标签
     */
    links?: string[];
    /**
     * 样式名
     */
    className?: string;
    /**
     * emails集合 i18n文案key值必须是 mail1，mail2, mail3...标签
     */
    emails?: string[];
    /**
     * tels联系电话集合 i18n文案key值必须是 tel1，tel2, tel3...标签
     */
    tels?: string[];
    /**
     * text文本
     */
    text: string;
}

/**
 * 维护: kalkin
 *
 * Terms & Conditions / Footnotes， 支持多语言t.rich函数， /jp/delta-3-series-portable-power-station 使用中
 */
export default function EfFootNotes({ links = [], emails = [], tels = [], className, text, langKey = '' }: EfFootNotesProps) {
    const { t } = useLang(langKey);
    const prefixCls = `ef-foot-notes`;
    const classes = classNames(prefixCls, {
        [`${className}`]: className,
    });

    const iteratorMap = (data: string[], type: string) => {
        let res = {};
        const prefix = type === 'email' ? 'mailto:' : type === 'tel' ? 'tel:' : '';
        const prefixText = type === 'email' ? 'mail' : type === 'tel' ? 'tel' : 'a';
        data.forEach(
            (item: string, k: number) =>
                (res[`${prefixText}${k + 1}`] = (tx: string) => (
                    <a className={`${prefixCls}-link`} href={`${prefix}${item}`} target="_blank">
                        {tx}
                    </a>
                )),
        );
        return res;
    };

    return (
        <div className={classes}>
            <div className={`${prefixCls}-content`}>
                {t.rich(text, {
                    ...iteratorMap(links, 'link'),
                    ...iteratorMap(emails, 'email'),
                    ...iteratorMap(tels, 'tel'),
                    title: (tx: string) => <p className={`${prefixCls}-title`}>{tx}</p>,
                })}
            </div>
        </div>
    );
}
